import { RemoteConstants } from "../../../data/remote/RemoteConstants";
import { PdvInfoAction } from "../../../presentation/redux/actions/PdvInfoAction";
import { UIActions } from "../../../presentation/redux/actions/UIActions";
import { errorManager } from "../../../presentation/utils/errorManager";

/* eslint-disable no-unused-vars */
export const getInfo = async (token, dispatch) => {
  try {
    const params = new URLSearchParams({
      token: token
    });
    const peticion = await fetch(`${RemoteConstants.BASE_URL}pos/get/info?${params.toString()}`, {
      method: 'GET',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(resp => {
        return resp.json();
      })
      .then(data => {
        if (data.code === 'OK') {
          dispatch(PdvInfoAction.setPdvInfo(data.data));
        } else {
          errorManager(data.userMessage);
        }
      });
  } catch (error) {
    errorManager(error);
  }
  dispatch(UIActions.uiLoadInactive());
}